/*
=========================================================
* Material Kit 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Container from "@mui/material/Container";
import Divider from "@mui/material/Divider";

// Material Kit 2 React components
import MKBox from "components/MKBox";
import ScrollReveal from "components/ScrollReveal";

// Material Kit 2 React examples
import DefaultCounterCard from "examples/Cards/CounterCards/DefaultCounterCard";

function Counters() {
  const fecha = new Date();
  const fechaNacimiento = new Date("1901-05-26");
  const cantidadAnios = fecha.getFullYear() - fechaNacimiento.getFullYear();

  return (
    <MKBox component="section" className="school-stats" py={{ xs: 4, md: 5 }}>
      <Container>
        <MKBox
          sx={{
            display: "grid",
            gridTemplateColumns: { xs: "1fr", md: "1fr auto 1fr" },
            gap: { xs: 2.5, md: 3 },
            alignItems: "stretch",
            maxWidth: "900px",
            mx: "auto",
          }}
        >
          <MKBox display="flex" minWidth={0}>
            <ScrollReveal sx={{ width: "100%" }}>
              <DefaultCounterCard
                color="primary"
                count={cantidadAnios}
                title="Años de nuestro instituto"
                description="Desde el 26 de Mayo de 1901"
              />
            </ScrollReveal>
          </MKBox>
          <Divider
            orientation="vertical"
            flexItem
            sx={{ display: { xs: "none", md: "block" }, opacity: 0.35 }}
          />
          <MKBox display="flex" minWidth={0}>
            <ScrollReveal delay={120} sx={{ width: "100%" }}>
              <DefaultCounterCard
                count={1100}
                color="primary"
                suffix="+"
                title="Cantidad de estudiantes"
                description="La ciudad nos elige desde hace más de 100 años"
              />
            </ScrollReveal>
          </MKBox>
        </MKBox>
      </Container>
    </MKBox>
  );
}

export default Counters;
